<template>
    <v-container class="parent">
        <span v-if="!tokenValid" style="font-size : 18px;">Token expirado!</span>
        <v-card class="card" elevation="8"  v-if="tokenValid">
            <v-card-title>
                Redefinir senha
                <v-spacer></v-spacer>
                <v-icon>
                    mdi-account-lock
                </v-icon>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field label="Nova senha" type="password" outlined append-icon="mdi-lock" clearable v-model="access.password">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field label="Confirme a senha" type="password" outlined append-icon="mdi-lock" clearable v-model="access.confirmation">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn style="width:100%; background:black;color:white;" :disabled="access.password != access.confirmation || !access.password || !access.confirmation" @click="savePassword()">
                    Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<script>
import updateUserPassword from '../../../../src/app/usuario/updateUserPassword'
import verifyPasswordRecoveryToken from '../../../../src/app/usuario/verifyPasswordRecoveryToken'
export default {
    data() {
        return {    
            userId : this.$route.params.userId,
            access:{
                password : '',
                confirmation : ''
            },
            tokenValid : false
        }
    },  
    methods : {
        async savePassword(){
            if(this.access.password != this.access.confirmation) return
            
            let dt = {
                newPassword : this.access.password,
                USUARIO_ID : this.$route.params.id
            }
            await updateUserPassword({data : dt}).then(response => {
                console.log(response)
                this.$router.push('/')
            })
        }
    },
    async beforeCreate(){
        console.log(this.$route.params)
        let token = this.$route.params.token.split('token=')[1]
        await verifyPasswordRecoveryToken({token : token}).then(response => {
            console.log(response.data)
            if(response.status == 200 && !response.data.error){
                this.tokenValid = true
            }
        }) 
    }
}
</script>
<style scoped>
    .parent{
        height:95vh;
        display: grid;
        place-items:center;
    }
    .card{
        min-width:30%;
        min-height:50%;
        padding:20px;
    }
</style>
